import {container, title, grayColor, primaryColor, secondaryColor} from "../../../nextjs-material-kit.js";
import headerLinksStyle from "../../components/headerLinksStyle.js";

const navbarsStyle = (theme) => ({
  container: {
    ...container(theme),
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  list: {
    ...headerLinksStyle(theme).list,
    display: "flex",
    width: "100%",
    justifyContent: "start !important",
    [theme.breakpoints.down('md')]: {
      flexDirection: "column",

      '.MuiPopper-root': {
        marginTop: '-45px',
        marginBottom: '60px',
      }
    }
  },
  listItem: {
    ...headerLinksStyle(theme).listItem,
    width: "initial",
    [theme.breakpoints.down('md')]: {
      paddingBottom: "4px",
    }
  },
  listItemEnd: {
    ...headerLinksStyle(theme).listItemEnd,
    // TODO figure out why this item's parent isn't `flex`ing.
    alignSelf: "flex-end",
  },
  section: {
    padding: "70px 0",
    paddingTop: "0",
  },
  btnCustomDropdown: {
    fontSize: "14.6px !important",

    [theme.breakpoints.down('md')]: {
      fontSize: "13px",
      width: "100%",
      marginBottom: "10px",
      margin: 0,
    },
  },
  btn: {
    padding: '8px 30px'
  },
  customButton: {
    marginRight: "0 !important",
    // paddingRight: "50px !important",
    width: "100%",
  },
  dropDown: {
    backgroundColor: "#406c98",
    fontFamily: "var(--font-brandon-grotesque)",
    textTransform: "capitalize",
    fontSize: "17px",
    padding: "6px 12.5px",
    margin: "5px 8px",
    marginLeft: "0px",
    boxShadow: "none !important",
    borderRadius: "0 !important",
    "&:hover": {
      backgroundColor: primaryColor
    },
    "&:focus": {
      backgroundColor: primaryColor,
    },
    "&:active": {
      backgroundColor: primaryColor,
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 13,
    },
  },
  dropDownInEffect: {
    backgroundColor: primaryColor,
  },
  title: {
    ...title,
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    maxWidth: "90%",
  },
  navbar: {
    marginBottom: "-20px",
    zIndex: "100",
    position: "relative",
    "& header": {
      borderRadius: "0",
    },
  },
  navigation: {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    marginTop: "0",
    minHeight: "740px",
  },
  formControl: {
    [theme.breakpoints.down('lg')]: {
      margin: "10px 0 0 15px !important",
      color: grayColor,
    },
    margin: "10px 0 0 0 !important",
    paddingTop: "0",
  },
  inputRootCustomClasses: {
    margin: "0!important",
  },
  searchIcon: {
    width: "20px",
    height: "20px",
    color: "inherit",
  },
  img: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
  },
  imageDropdownButton: {
    [theme.breakpoints.down('lg')]: {
      top: "0",
      margin: "5px 15px",
    },
    padding: "0px",
    top: "4px",
    borderRadius: "50%",
    marginLeft: "5px",
  },
});

export default navbarsStyle;
